"use strict";
/**
 * @module Candidates
 */
Object.defineProperty(exports, "__esModule", { value: true });
